exports.list = {
    path: '/buku_besar',
    name: 'buku_besar', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/buku_besar/List.vue"),
  }
  